import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingBlock } from '../components/Spinner'
import { AccountFanslyDeps } from './FanslyDeps'
import { FANSLY_PAGES, type FanslyPageProps } from './registry'

/** One Fansly page of an account, with the account's Fansly deps (AccountCrm renders it). */
export function FanslyPageHost(props: FanslyPageProps) {
  const { t } = useTranslation('fansly')
  const Page = FANSLY_PAGES[props.page]
  if (!Page) return null
  return (
    <AccountFanslyDeps accountId={props.accountId}>
      <Suspense fallback={<LoadingBlock label={t('loading')} />}>
        <Page {...props} />
      </Suspense>
    </AccountFanslyDeps>
  )
}
